import { createStore } from '@'

export const $regions = createStore('mapping:regions')
export const $hotelMappings = createStore('mapping:hotelMappings')
export const $hotelInfoMapping = createStore('mapping:hotelInfoMapping')
export const $hotelMappingFrom = createStore('mapping:hotelMappingFrom')
export const $hotelSupplierDestinationMapping = createStore('mapping:hotelSupplierDestinationMapping', {})
export const $hotelRegionInfo = createStore('mapping:hotelRegionInfo', [])
export const $epsRegionInfo = createStore('mapping:epsRegionInfo', [])
export const $coverageCatalogs = createStore('mapping:coverageCatalogs', null)
export const $hotelCoverage = createStore('mapping:hotelCoverage', null)
export const $hotelCoverageQuery = createStore('mapping:hotelCoverageQuery', null)
export const $hotelCoverageLoading = createStore('mapping:hotelCoverageLoading', false)
export const $regionCoverage = createStore('mapping:regionCoverage', null)
export const $regionCoverageQuery = createStore('mapping:regionCoverageQuery', null)
export const $regionCoverageLoading = createStore('mapping:regionCoverageLoading', false)
export const $supplierCoverage = createStore('mapping:supplierCoverage', null)
export const $supplierCoverageQuery = createStore('mapping:supplierCoverageQuery', null)
export const $supplierCoverageLoading = createStore('mapping:supplierCoverageLoading', false)

export const $amenitiesGoQuo = createStore('mapping:amenitiesGoQuo')
export const $amenitiesUnmap = createStore('mapping:amenitiesUnmap')
export const $amenitiesType = createStore('mapping:amenitiesType')
export const $amenitiesProvider = createStore('mapping:amenitiesProvider')
